import { Upload } from '@wellesley/openapi'
import { isPlayableVideo } from '../isPlayableVideo'
import isUploadType from 'helpers/isUploadType'

type HelperProps = {
  upload: Upload
  videoExtensions?: string[]
}

const isUploadStable = ({ upload, videoExtensions }: HelperProps) => {
  const isVideo = isUploadType({ source: upload, type: 'VIDEO' })
  const isImage = isUploadType({ source: upload, type: 'IMAGE' })
  const uploadError = upload.error

  const hasPlayableSource = upload.files.some((file) =>
    isPlayableVideo({ file, allowedExtensions: videoExtensions }),
  )

  const hasImages =
    isImage &&
    upload.files.some(
      (file) => isUploadType({ source: file, type: 'IMAGE' }) && file.uri,
    )

  const isUploadStable =
    !uploadError && ((isVideo && hasPlayableSource) || (isImage && hasImages))

  return isUploadStable
}

export default isUploadStable
